var $$ = $$ || {};

$$.FixedHeader = class FixedHeader {
	constructor (root) {
		this.root = root;

		this._bindEvents();
	}

	_bindEvents () {
		$$.window
			.on('scroll', _.debounce((event) => {
				var scrollTop = event.currentTarget.scrollY;

				if ( scrollTop > 0 ) {
					this.root.css({ backgroundColor: '#fff' });
				} else {
					this.root.css({ backgroundColor: 'transparent' });
				}
			}, 100, {
				leading: true
			}))
			.trigger('scroll');
	}
};
